import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import NumberField from 'components/NumberField/NumberField';
import {
  GROSS_MARGIN_ROLLING_AMOUNT,
  GROSS_MARGIN_ROLLING_CURRENCY,
  GROSS_MARGIN_ROLLING_PERCENTS,
} from 'constants/formFields';
import { NUMBER_FORMATS } from 'constants/interfaces';

import type IGrossMarginFields from '../../interfaces/IGrossMarginFields';

import styles from '../../sass/CreateProfitCentreView.module.scss';

function GrossMarginFields({ control }: IGrossMarginFields) {
  const { t } = useTranslation();

  return (
    <div className={styles.wrapper}>
      <Controller
        control={control}
        name={GROSS_MARGIN_ROLLING_AMOUNT}
        render={({ field: { name, value, onChange }, fieldState: { error } }) => (
          <div>
            <div className={styles.fieldWithCurrency}>
              <NumberField
                label={t('profitCentres.createProfitCentre.fields.actualGross')}
                name={name}
                value={value}
                error={error?.message}
                onChange={(values) => onChange(values.value)}
                placeholder={t('profitCentres.createProfitCentre.fields.actualGross')}
                className={styles.valueInput}
                hideTextError
                required
              />
              <Controller
                control={control}
                name={GROSS_MARGIN_ROLLING_CURRENCY}
                render={({
                  field: { value: valueCurrency },
                }) => (
                  <span className={`${styles.currencyInput} ${error?.message ? styles.errorBorder : ''}`}>
                    {`M, ${valueCurrency}`}
                  </span>
                )}
              />
            </div>
            {error?.message ? <span className={styles.errorMessage}>{error.message}</span> : null}
          </div>
        )}
      />
      <Controller
        control={control}
        name={GROSS_MARGIN_ROLLING_PERCENTS}
        render={({ field: { name, value, onChange }, fieldState: { error } }) => (
          <NumberField
            name={name}
            value={value}
            label={t('profitCentres.createProfitCentre.fields.totalGross')}
            error={error?.message}
            onChange={(values) => onChange(values.value)}
            type={NUMBER_FORMATS.percent}
            placeholder={t('profitCentres.createProfitCentre.fields.totalGross')}
            allowNegative={false}
            required
            disabled
          />
        )}
      />
    </div>
  );
}

export default GrossMarginFields;
